import TestimonialDetails from './TestimonialDetails';

export default TestimonialDetails;
